import React from "react";
import styles from './modal.module.css';

interface Props {
    title: string,
    subTitle?: string,
    containerMargin?: string,
    className?: string
}

const ModalTitle = ({ title, subTitle, containerMargin, className }: Props) => {
    return <div style={{ marginBottom: containerMargin ?? "3rem" }} className={`${styles.ModalTitleContainer} ${className}`}>
        {title && <h2 className={styles.ModalTitleText}>
            {title}
        </h2>}
        {subTitle && <div className={styles.ModalSubTitle}>
            {subTitle}
        </div>}
    </div>
}

export default ModalTitle;